import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Row, Col, ControlLabel, Button, RadioGroup, Radio, Icon } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import './styles.less'
import InputForm from '../../components/forms/input/InputForm'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { cloneDeep } from 'lodash-es'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import AppContext from '../../context/AppContext'
import { v4 as uuidv4 } from 'uuid'
import {
  getProgressReportSubprojectClose,
  saveSocialfactors,
} from '../../redux/actions/progressReportSubproject'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { getValueFromOptions } from '../../utils/dataUtil'
import { useDispatch } from 'react-redux'
import { getSchemaSubProjectDep6Sidebar } from '../../redux/actions/sidebar'

export default function ConduciveHealthWidget({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressActivityId,
  setProgressReportsId = () => {},
  ...props
}) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { theme } = React.useContext(AppContext)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [conduciveHealthValue, setConduciveHealthValue] = useState([])
  const [deleteId, setDeleteId] = useState([])
  const [mapValues, setMapValues] = useState(new Map())
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  useEffect(() => {
    setConduciveHealthValue(formSchema?.conduciveHealth?.values || null)
    setDataToMap(_schema?.conduciveHealth?.values)
  }, [_schema])

  const setDataToMap = (value) => {
    var objMap = new Map()
    value?.forEach((e) => {
      objMap.set(e.id, e)
    })
    setMapValues(objMap)
  }

  const onSubmit = (data) => {
    let combinedData = []
    conduciveHealthValue?.forEach((i) => {
      let mapval = mapValues.get(i.id)
      combinedData.push({
        id: mapval.id === null ? '' : mapval.id.indexOf('addNew-') == -1 ? mapval.id : '',
        detailOfSocialfactors: mapval.detail,
        envFlag: mapval.environmental,
      })
    })

    const request = {
      projectVersionId: projectVersionId || '',
      projectCode: projectCode || '',
      period: period,
      installmentPlanDetailId: installmentPlanId,
      socialfactorsLists: combinedData,
      deleteSocialfactorsIds: deleteId || [],
    }

    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveSocialfactors(request)

      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setProgressReportsId(response.progressReportsId)
        handleGetSchema()
        await dispatch(getSchemaSubProjectDep6Sidebar(projectId))
      } else {
        setErrorMsg({ type: 'error', description: response.errorMessage })
      }
    } catch (error) {
      console.error('try catch error ', error)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getProgressReportSubprojectClose(
        period,
        projectCode,
        projectVersionId,
        installmentPlanId
      )

      if (response) {
        setFormSchema(response?.forms?.otherOutcomes)
        setConduciveHealthValue(response?.forms?.otherOutcomes?.conduciveHealth?.values || null)
        setDataToMap(response?.forms?.otherOutcomes?.conduciveHealth?.values)
      }
    } catch (e) {
      console.log(' error', e)
    }
    doneLoading()
  }

  const handleAdd = () => {
    let conduciveHealthVal = cloneDeep(conduciveHealthValue)
    let mapVal = cloneDeep(mapValues)
    let data = {
      id: 'addNew-' + uuidv4(),
      detailOfSocialfactors: '',
      envFlag: null,
    }

    conduciveHealthVal.push(data)
    mapVal.set(data.id, data)
    setMapValues(mapVal)
    setConduciveHealthValue(conduciveHealthVal)
  }

  const handleDelete = (item, index) => {
    let conduciveHealthVal = cloneDeep(conduciveHealthValue)
    let mapVal = cloneDeep(mapValues)
    if (index > -1) {
      conduciveHealthVal.splice(index, 1)
    }
    if (!item.id.startsWith('addNew-')) {
      setDeleteId([...deleteId, item.id])
    }
    mapVal.delete(item.id)
    setMapValues(mapVal)
    setConduciveHealthValue(conduciveHealthVal)
  }

  return (
    <div>
      <Panel
        header={formSchema.conduciveHealth.title}
        collapsible
        defaultExpanded
        style={{ marginTop: 10 }}
      >
        <div style={{ paddingLeft: 30, paddingRight: 0, marginTop: -20 }}>
          {conduciveHealthValue &&
            conduciveHealthValue.map((item, index) => {
              return (
                <>
                  <Row style={{ marginTop: 10 }}>
                    <Col lg={22} md={22} sm={22} xs={22}>
                      {!disabled ? (
                        <>
                          <ControlLabel
                            className={classNames(
                              isRequired(formSchema.conduciveHealth.input.detailInput.validators) &&
                                'required'
                            )}
                          >
                            {`${formSchema.conduciveHealth.input.detailInput.label}`}
                          </ControlLabel>
                          <InputForm
                            schema={formSchema.conduciveHealth.input.detailInput}
                            name={`${formSchema.conduciveHealth.input.detailInput.name}_${item.id}`}
                            placeholder={
                              'ระบุ' + formSchema.conduciveHealth.input.detailInput.label
                            }
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            hideLabel={true}
                            key={index}
                            value={mapValues?.get(item.id)?.detail}
                            onChange={(value) => {
                              let nObj = cloneDeep(mapValues)
                              nObj.get(item.id).detail = value
                              setMapValues(nObj)
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <b> {formSchema.conduciveHealth.input.detailInput.label}</b>
                          <p>{mapValues?.get(item.id)?.detail}</p>
                        </>
                      )}
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>

                  <Row style={{ marginTop: 10 }}>
                    <Col lg={22} md={22} sm={22} xs={22}>
                      <div style={{ padding: 10 }}>
                        {!disabled ? (
                          <>
                            <ErrorMessage
                              error={
                                errors[
                                  `${formSchema.conduciveHealth.input.environmentalInput.name}_${index}`
                                ]
                              }
                            />
                            {/* {console.log(errors)} */}
                            <Controller
                              name={`${formSchema.conduciveHealth.input.environmentalInput.name}_${index}`}
                              // defaultValue={parseInt(item.environmental)}
                              defaultValue={
                                isNaN(parseInt(item.environmental))
                                  ? null
                                  : parseInt(item.environmental)
                              }
                              control={control}
                              rules={isValidators(
                                formSchema.conduciveHealth.input.environmentalInput.validators
                              )}
                              render={(props) => {
                                return (
                                  <RadioGroup
                                    value={mapValues?.get(item.id)?.environmental}
                                    onChange={(value) => {
                                      props.onChange(value)
                                      let nObj = cloneDeep(mapValues)
                                      nObj.get(item.id).environmental = value
                                      setMapValues(nObj)
                                    }}
                                  >
                                    <ControlLabel
                                      className={classNames(
                                        isRequired(
                                          formSchema.conduciveHealth.input.environmentalInput
                                            .validators
                                        ) && 'required'
                                      )}
                                    >
                                      {formSchema.conduciveHealth.input.environmentalInput.label}
                                    </ControlLabel>

                                    {formSchema.conduciveHealth.input.environmentalInput.options.map(
                                      (item, index) => (
                                        <Radio key={index} value={`${item.value}`}>
                                          {item.label}
                                        </Radio>
                                      )
                                    )}
                                  </RadioGroup>
                                )
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <b> {formSchema.conduciveHealth.input.environmentalInput.label}</b>

                            <p>
                              <Icon
                                icon="dot-circle-o"
                                style={{ marginRight: 5, color: '#14997a' }}
                              />
                              {`${getValueFromOptions(
                                formSchema.conduciveHealth.input.environmentalInput.options.map(
                                  (item, index) => {
                                    return {
                                      ...item,
                                      value: item.value.toString(),
                                    }
                                  }
                                ),
                                mapValues?.get(item.id)?.environmental || '0'
                              )}`}
                            </p>
                          </>
                        )}
                      </div>
                    </Col>
                    {!disabled ? (
                      <Col lg={2} md={2} sm={2} xs={2}>
                        {conduciveHealthValue.length > 1 && (
                          <div style={{ marginTop: 33 }}>
                            <Button color="red" onClick={() => handleDelete(item, index)}>
                              ลบ
                            </Button>
                          </div>
                        )}

                        {conduciveHealthValue.length == index + 1 && (
                          <>
                            <div style={{ marginTop: 33 }}>
                              <Button color="blue" onClick={() => handleAdd()}>
                                เพิ่ม
                              </Button>
                            </div>
                          </>
                        )}
                      </Col>
                    ) : (
                      <Col lg={2} md={2} sm={2} xs={2}></Col>
                    )}
                  </Row>
                </>
              )
            })}
        </div>
        {!disabled && (
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <div style={{ paddingLeft: 40, paddingRight: 25 }}>
                <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmit)}>
                  บันทึก
                </SaveButton>
              </div>
            </Col>
          </Row>
        )}
      </Panel>
    </div>
  )
}
